import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './components/ErrorBoundary';
import Main from './components/Main';
import { setPlatformURI } from './constants';
import { initializeOptions } from './services/options';
import { reportError } from './utils/errors';

// This separated startup function allows us to test the initialization of the application
export const startup = async () => {
    const options = await initializeOptions();

    const rootElement = document.querySelector(options.rootElementSelector);

    setPlatformURI(options.platformUri);

    if (rootElement === null) {
        reportError(`Cannot find an element with the selector: "${options.rootElementSelector}"`);
    } else {
        const root = createRoot(rootElement);
        /**
         * Render the Root component into the chosen HTML element
         */
        root.render(
            <StrictMode>
                <ErrorBoundary>
                    <Main
                        flowId={options.flowId}
                        flowVersion={options.flowVersionId}
                        stateId={options.stateId}
                        tenantId={options.tenantId}
                        selectedOutcomeId={options.selectedOutcomeId}
                        authenticationToken={options.authenticationToken}
                        options={options}
                        executionMode={options.mode}
                        environmentId={options.environmentId}
                        culture={options.culture}
                    />
                </ErrorBoundary>
            </StrictMode>,
        );

        return root;
    }

    return;
};
